import styled from "styled-components"

export const EquipoWrapper = styled.div`
  padding: 80px 0;
`
